export function bindMagazineMenus(root, document) {
  const openMenus = () => [...root.querySelectorAll("details[open]")];
  const dismissOutside = (event) => {
    for (const menu of openMenus()) if (!menu.contains(event.target)) menu.open = false;
  };
  const followLink = (event) => {
    if (event.target.closest?.("a[href]")) for (const menu of openMenus()) menu.open = false;
  };
  const escape = (event) => {
    if (event.key !== "Escape") return;
    const menus = openMenus();
    for (const menu of menus) menu.open = false;
    if (menus.some(menu => menu.contains(document.activeElement))) menus[0]?.querySelector("summary")?.focus();
  };
  document.addEventListener("click", dismissOutside);
  document.addEventListener("click", followLink);
  document.addEventListener("keydown", escape);
  return () => {
    document.removeEventListener("click", dismissOutside);
    document.removeEventListener("click", followLink);
    document.removeEventListener("keydown", escape);
  };
}
